export default {
  "snsShareButton.facebook.title": "Facebook で Share !",
  "snsShareButton.facebook.share.button": "シェア",
  "snsShareButton.x.title": "Twitter で Share !",
  "snsShareButton.x.share.button": "ツイート",
} as const;
